import WorkTypeTag from './WorkTypeTag';

export default WorkTypeTag;
